import { FormFieldValue } from "../interface";

export function compareValues(value0?: FormFieldValue, value1?: FormFieldValue): boolean {
  const value0String = value0?.toString()?.trim()?.toLocaleLowerCase() ?? '';
  const value1String = value1?.toString()?.trim()?.toLocaleLowerCase() ?? '';
  return value0String === value1String;
}